<template>
  <div class="pageContent">
    <div class="pageTitleBox">
      <img src="../../assets/images/file2.png" alt="logo" class="pageTitleIcon">文档下载
    </div>
    <div class="pageContentWd">
      <template v-if="loading">
        <div class="card" style="padding:10px;" v-for="i in 4" :key="i">
          <a-skeleton active :title="false" :paragraph="{rows: 4}" />
        </div>
      </template>
      
      <div class="card" v-for="item in list" :key="item.id">
        <div class="cardTop">{{ item.name }}</div>
        <div class="cardMiddle">发布时间：{{ item.gmtCreate }}</div>
        <a-divider class="cardXian"/>
        <a class="cardBottom" :href="item.url" download>
          <img src="../../assets/images/downLoad2.png" alt="DownLoad" class="cardBottomDl">
          <div class="cardBottomWenzi">下载</div>
        </a>
      </div>
    </div>
    <div class="paginationBox">
      <a-pagination size="small" :total="total" :pageSize="5" show-quick-jumper @change="tabelChange" :show-total="total => `共${total}条记录`" />
    </div>
  </div>
</template>
  
<script>
import { http } from '@/utils/http'

export default {
  name: 'wendang',
  data() {
    return {
      pageNum: 1,
      pageSize: 12,
      list: [],
      loading: true,
      total: 0
    }
  },
  created() {
    this.onload()
  },
  methods: {
    onload() {
      let parameter = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.loading = true
      this.list = []
      http('/system/center/getList', 'POST', parameter).then(res => {
        this.loading = false
        if (res.success) {
          this.list = res.data.resultList
          this.total = res.data.total
        }
      })
    },
    tabelChange(page) {
      this.pageNum = page
      this.onload()
    }
  }
}
</script>

<style lang="less" scoped>
.pageContent {
  width: 1200px;
  padding: 0 14px;
  margin: 18px auto;
}
.pageTitleBox {
  margin-bottom: 19px;
}
.listItem {
  height: 140px;
  border-bottom: 1px solid #D9D9D9;
  // display: inline-block;
  position: relative
}
.pageContentWd {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  // align-content: flex-start;
}
.card {
  width: 234px;
  height: 141px;
  border: 1px solid #D9D9D9;
  text-align: center;
  margin-bottom: 29px;
  margin-left: 54px;
}
.cardTop {
  height: 44px;
  margin-top: 15px;
  margin-left: 22px;
  margin-right: 23px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  line-height: 22px;
  font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cardMiddle {
  height: 20px;
  margin-top: 15px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #666;
  line-height: 20px;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
}
.cardXian {
  margin-top: 5px;
  margin-bottom: 0;
}
.cardBottom {
  width: 234px;
  height: 42px;
  display: flex;
  align-items: center;
}
.cardBottomDl {
  margin-left: 83px;
  width: 25px;
  height: 25px;
}
.cardBottomWenzi {
  margin-left: 7px;
  font-size: 16px;
  font-weight: 400;
  color: #519bcd;
}
</style>